import React from "react"
import { motion } from "framer-motion"
import { Sparkles } from "lucide-react"
import { BatchContactWidget } from "../components/ui/BatchContactWidget"
import CTASection from "../components/marketing/CTASection"

import { OmniConcierge } from "../components/voice/OmniConcierge"

export default function Demos() {
  return (
    <div className="pt-20">
      <section className="py-24 md:py-32 relative overflow-hidden text-center">
        <div className="absolute inset-0 bg-gradient-to-b from-purple-500/5 via-transparent to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/20 mb-6">
              <Sparkles className="w-4 h-4 text-purple-400" />
              <span className="text-purple-300 text-sm font-medium">Interactive Demo</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
              See AI <span className="text-purple-400">Intelligence</span> in Action
            </h1>

            <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-3xl mx-auto">
              Test drive live OpenAI-powered voice and document ingestion flows. Unconnected actions fail closed instead of pretending to schedule, transfer, or save CRM records.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 pb-24 space-y-24">
        <OmniConcierge />
        <BatchContactWidget />
      </div>
      
      <div className="max-w-4xl mx-auto mb-12 bg-slate-800/50 border border-purple-500/30 rounded-2xl p-8">
        <h3 className="text-2xl font-bold text-white mb-4">💡 Try These Commands</h3>
        <div className="grid md:grid-cols-2 gap-4 text-slate-300">
          <div>✅ "What services does Bridge offer?"</div>
          <div>✅ "What are your business hours?"</div>
          <div>✅ "How do I request a consultation?"</div>
          <div>✅ "What information should I include in my message?"</div>
          <div>✅ "Explain your AI workflow services"</div>
          <div>✅ "What happens after I contact Bridge?"</div>
        </div>
      </div>

      <CTASection />
    </div>
  )
}


